export const kycApiPaths = {
    kyc: 'organizations/:organizationId',
    submitKyc: 'organizations/:organizationId/submit',
} as const;
